const articleContent = document.querySelector(".article-template-content");
const summaryContainer = document.querySelector(".article-template-summary");

if (articleContent) {
  const headings = [...articleContent.querySelectorAll("h2")];
  const summaryContent = document.querySelector(".article-template-summary-content");

  if (headings.length > 0) {
    const summaryHTML = headings
      .map((heading) => {
        const text = heading.innerHTML;
        const slug = text
          .toLowerCase()
          .replace(/[^\w\s-]/g, "")
          .replace(/\s+/g, "-");
        return `<h2><a href="#${slug}">${text}</a></h2>`;
      })
      .join("");

    summaryContent.innerHTML = summaryHTML;

    headings.forEach((heading) => {
      heading.setAttribute(
        "id",
        heading.innerHTML
          .toLowerCase()
          .replace(/[^\w\s-]/g, "")
          .replace(/\s+/g, "-")
      );
    });
  }
}
